(ns app.front.view.admin.migration.backfill-planning-archiving-phases
  (:require [app.front.view.admin.migration.template :as admin-migration-template]
            [core.front.event :refer [>evt]]))

(def task-id :app.admin.migration.task/backfill-planning-archiving-phases)

(defn view [match]
  [admin-migration-template/admin-page-for-migration
   {:task-id   task-id
    :title     "Backfill Planning archiving phases"
    :help-text (str "Creates missing archiving phases, default archiving fields, sensitivity levels, and Archivist "
                    "authorizations for eligible Planning workspaces with archiving enabled. This fixes Planning "
                    "workspaces which can't be archived while setting to finished")}
   match])

(def route
  {:name        :view/admin.migration.backfill-planning-archiving-phases
   :view        view
   :controllers [{:start (fn [_]
                           (>evt [::admin-migration-template/fetch-migration-tasks task-id]))}]})
